<template>
  <div id="my-nav" style="padding-bottom:20px;">
    <Button
      size="small"
      @click="
        goto({ name: 'cholding', params: { ccass_id: $route.params.ccass_id } })
      "
      :type="$route.name == 'cholding' ? 'primary' : 'default'"
      >席位持股查询</Button
    >
    <Button
      size="small"
      @click="
        goto({ name: 'cchange', params: { cid: $route.params.ccass_id } })
      "
      :type="$route.name == 'cchange' ? 'primary' : 'default'"
      >席位持股变动</Button
    >
    <Button
      size="small"
      @click="goto({ name: 'allccass' })"
      :type="$route.name == 'allccass' ? 'primary' : 'default'"
      >席位持股总览</Button
    >
  </div>
</template>

<style>
#my-nav a {
  text-decoration: none;
}
</style>
<script>
export default {
  methods: {
    goto(target) {
      this.$router.push(target);
    }
  }
};
</script>
